import { render, staticRenderFns } from "./ContratoEdit.vue?vue&type=template&id=7f073169&"
import script from "./ContratoEdit.vue?vue&type=script&lang=js&"
export * from "./ContratoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports